import FieldWrapper from '@features/ui-form/components/FieldWrapper';
import Autocomplete from '@features/ui-form/components/Autocomplete';
import { SelectProps } from '@features/ui-form/components/Select';
import { WrappedSelectProps } from '@features/ui-form/types';
import { useTranslation } from 'next-i18next';
import type { ChangeEvent } from 'react';
import { SST_TYPES, SstType } from './enum';

export const SstTypeInput = ({ value, onChange, hideError = false, required = false }: WrappedSelectProps) => {
  const { t } = useTranslation('common');
  const SstTypeAutocomplete = Autocomplete(false, false);

  const handleChange = (event: { target: { value: string } }) => {
    if (!onChange) return;

    const raw = event.target.value;
    const parsed = raw ? (JSON.parse(raw) as SstType) : ('' as unknown as SstType);

    onChange({
      target: {
        name: 'sstType',
        value: parsed,
      },
    } as unknown as ChangeEvent<HTMLSelectElement>);
  };

  return (
    <FieldWrapper name="sstType" label={t('sstEvent.sstType')} hideError={hideError} required={required}>
      {SstTypeAutocomplete({
        value: value ? JSON.stringify(value) : '',
        onChange: handleChange,
        options: Object.values(SST_TYPES).map((sstType: SstType) => {
          const label = t(`sstEvent.sstType.${sstType}`);
          return {
            value: sstType,
            label,
            labelString: label,
          };
        }),
        placeholder: t('sstEvent.sstType.placeholder'),
      })}
    </FieldWrapper>
  );
};

export const SstTypeToolbarInput = ({ value, onChange, ...rest }: Omit<SelectProps, 'options'>) => {
  const { t } = useTranslation('common');
  const SstTypeToolbarAutocomplete = Autocomplete(false, false);

  const handleChange = (event: { target: { value: string } }) => {
    if (!onChange) return;

    const raw = event.target.value;
    const parsed = raw ? (JSON.parse(raw) as SstType) : ('' as unknown as SstType);

    onChange({
      target: {
        name: rest.name ?? 'sstType',
        value: parsed,
      },
    } as unknown as ChangeEvent<HTMLSelectElement>);
  };

  const options = Object.values(SST_TYPES).map((sstType: SstType) => {
    const label = t(`sstEvent.sstType.${sstType}`);
    return {
      value: sstType,
      label,
      labelString: label,
    };
  });

  return SstTypeToolbarAutocomplete({
    value: value ? JSON.stringify(value) : '',
    onChange: handleChange,
    options,
    placeholder: t('sstEvent.sstType.placeholder'),
    inputContainerStyle: { backgroundColor: 'var(--joy-palette-white)' },
  });
};
